const EMPTY_ARRAY = [];

export const selectSequenceMilestones = ({ milestoneDefinitions }) =>
  milestoneDefinitions?.milestoneDefinitionsCollection?.sequenceMilestones || EMPTY_ARRAY;

export const selectPermanentMilestones = ({ milestoneDefinitions }) =>
  milestoneDefinitions?.milestoneDefinitionsCollection?.permanentMilestones || EMPTY_ARRAY;
